/* eslint-disable no-console */

let websock = null;
let global_callback = [];
import {Message} from 'element-ui';
import router from '../router'
class socketApi {

    initWebSocket() { //初始化weosocket
        //ws地址
        let wsuri = "wss://server.modijiaoyu.com/ws";
        //let wsuri = "ws://49.235.247.143:5200";
        // let wsuri = "ws://192.168.2.71:5200";

        websock = new WebSocket(wsuri);
        websock.onmessage = (e) => {
            this.websocketonmessage(e);
        };
        websock.onclose = (e) => {
            this.websocketclose(e);
        };
        websock.onopen = (e) => {
            // this.websocketOpen(e);
        };

        //连接发生错误的回调方法
        websock.onerror = function () {
        }
    }


// 实际调用的方法
    send(path, event, agentData = {}) {
        if (websock.readyState === websock.OPEN) {
            //若是ws开启状态
            let timestamp = new Date().getTime();
            this.websocketsend(path, event, agentData, timestamp)

        } else if (websock.readyState !== websock.CONNECTING) {
            // 若未开启 ，则等待1s后重新调用
            setTimeout(() => {
                this.send(path, event, agentData);
            }, 1000);
        } else {
            // 若是 正在开启状态，则等待1s后重新调用
            setTimeout(() => {
                this.send(path, event, agentData);
            }, 1000);
        }
    }


    addListen(path, callback) {
        if (!global_callback[path]) {
            global_callback[path] = [];
            global_callback[path][0] = callback;
        } else {
            global_callback[path][global_callback[path].length] = callback;
        }
    }

    removeListen(path) {
        if (global_callback[path].length>1) {
            global_callback[path].splice(global_callback[path].length-1,1);
        } else {
            delete global_callback[path]
        }
    }

//数据接收
    websocketonmessage(e) {
        let data = JSON.parse(e.data);
        if (data.status === "error") {
            if (data.data.hasOwnProperty('msg') && typeof (data.data.msg) != 'object') {
                if (data.data.msg == '请重新登陆') {
                    router.push({path: '/login'});
                    window.location.reload();
                }else{
                    Message.error(data.data.msg);
                }
            } else {
                let msg = '';
                Object.keys(data.data.msg).forEach(function (key) {
                    msg += data.data.msg[key][0] + '|'
                });
                Message.error(msg);
            }
            global_callback[data.path][0](data.event, data.data, data.status);
        } else if (data.status === "success") {
            if(global_callback[data.path]){
                for (let i = 0; i < global_callback[data.path].length; i++) {
                    global_callback[data.path][i](data.event, data.data, data.status);
                }
            }
        } else if (data.status === "check") {
            setTimeout(() => {
                websock.send(JSON.stringify({
                    'path': '/checkHeart',
                    'event': 'check',
                    'data': {},
                }));
            }, 5000)
        }
    }

//数据发送
    websocketsend(path, event, agentData, timestamp) {
        websock.send(JSON.stringify({
            'path': path,
            'event': event,
            'data': agentData,
            'timestamp': timestamp,
            'access_token': localStorage.token
        }));
    }

//关闭
    websocketclose(e) {
        this.initWebSocket();
    }

    websocketOpen(e) {

    }

    Close(){
        websock.close()
    }
}


export default new socketApi
